import { FormArray, FormControl } from '@angular/forms';
import {
  FormBuilderTypeSafe,
  FormGroupTypeSafe,
} from 'angular-typesafe-reactive-forms-helper';
import {
  IZavisniTrosakStavkaDto,
} from '@kodit/core/data-api';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ZavisanTrosakFromService {
  constructor(
    private _fb: FormBuilderTypeSafe,
  ) {}


  getFormArray(zavisniTroskovi?: IZavisniTrosakStavkaDto[]): FormArray {
    if (!zavisniTroskovi || zavisniTroskovi.length === 0) {
      return this._fb.array([]);
    }

    const result: FormArray = this._fb.array([]);
    zavisniTroskovi.forEach((s) => {
      result.push(this.getFormGroup(s));
    });
    return result;
  }


  public getFormGroup(
    zavisanTrosak?: IZavisniTrosakStavkaDto
  ): FormGroupTypeSafe<IZavisniTrosakStavkaDto> {
    return this._fb.group<IZavisniTrosakStavkaDto>({
      naziv: new FormControl(zavisanTrosak?.naziv),
      originalniBrojRacuna: new FormControl(zavisanTrosak?.originalniBrojRacuna),
      iznosBezPdv: new FormControl(zavisanTrosak?.iznosBezPdv ?? 0),
      iznosSaPdv: new FormControl(zavisanTrosak?.iznosSaPdv ?? 0),
    });
  }
}
